import { Fade } from 'react-awesome-reveal';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../banner/McoBanner';
import SectionMenu from '../section-menu/SectionMenu';
import { getMCOMenuItems } from '../view/utils';
import { useEffect, useMemo } from 'react';
import { setActiveSectionTab } from 'store/customer/customerViewSlice';

const McoSystem = (props) => {
  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const { selectedView, componentAccessList } = props;
  const dispatch = useDispatch();

  const sectionMenuItems = useMemo(
    () => getMCOMenuItems(selectedView, componentAccessList, roleId),
    [selectedView, componentAccessList, roleId]
  );

  const filteredMenuItems = sectionMenuItems
    .filter((section) => section.shouldRender)
    .map(({ shouldRender, ...rest }) => rest);

  useEffect(() => {
    dispatch(setActiveSectionTab(filteredMenuItems[0]?.key));
  }, [selectedCustomer?.value]);

  return (
    <div>
      <Fade>
        <Banner data={selectedView} />
      </Fade>

      <SectionMenu
        data={selectedView}
        role={roleId}
        menuItems={filteredMenuItems}
      />
    </div>
  );
};

export default McoSystem;
